<template>
  <v-row>
    <v-col>
      {{ label }}: {{ fileName }}
      <v-row>
        <v-col
          v-if="audio"
          cols="auto"
          class="pr-0"
        >
          <audio

            controls
            :src="sourceMedia"
          />
        </v-col>
        <v-col
          v-if="!audio"
          cols="12"
          class="pr-0"
        >
          <video
            controls
            :src="sourceMedia"
            width="500px"
          />
        </v-col>
        <v-col
          cols="2"
          class="mx-0 px-0 text-center"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                class="light-green lighten-4 "
                v-bind="attrs"
                v-on="on"
                @click="$refs.upload.click()"
              >
                <v-icon
                  color="#ffffff"
                  large
                >
                  mdi-upload
                </v-icon>
              </v-btn>
            </template>
            <span>Загрузить файл</span>
          </v-tooltip>
        </v-col>
        <v-col
          v-if="isUploaded"
          cols="2"
          class="mx-0 px-0 text-left"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                v-bind="attrs"
                class="red lighten-4"
                v-on="on"
                @click="removeFile"
              >
                <v-icon
                  color="#ffffff"
                  large
                >
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
            <span>Удалить файл</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <input
        id="input_file"
        ref="upload"
        type="file"
        style="display: none;"
        :accept="`${audio ? 'audio/mpeg,audio/ogg' : 'video/mp4'}`"
        @change="upload_files"
      >
    </v-col>
  </v-row>
</template>
<script>
import { fileData } from "@/views/loyalty/models/justpay-configuration-interface.model"

export default {
  props: {
    audio: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    mounted_flag: false,
    form: {
      file: ''
    },
    loader: {
      show: false
    },
  }),
  computed: {
    sourceMedia () {
      console.log('sourceMedia this.form.file', this.form.file)
      if (!this.form.file) return ''
      if (this.form.file.id) {
        return `${process.env.VUE_APP_JUSTPAY_URL}media/${this.form.file.name}`
      } else {
        return ''
      }
    },
    fileName () {
      if (this.form.file) {
        return this.form.file.name
      } else {
        return ''
      }
    },
    isUploaded () {
      if (!this.value) return false
      return !!this.value.id
    }
  },
  watch: {
    value: function () {
      this.init()
    }
  },
  mounted: function () {
    this.init()
  },
  methods: {
    init () {
        if (this.value) {
            if (this.value.id) {
              this.form.file = this.value
            }
        }
    },
    removeFile: function () {
      console.log('removeFile this.form.file', this.form.file)
      this.form.file = fileData
      this.$emit('input', this.form.file)
    },
    upload_files: function (event) {
      console.log('event', event)
      const files = event.target.files
      // this.error.file = ""

        const file = files[0]
        if (file) {
          if (file.size > 30000000) {
            // this.error.file = "Файл больше 30Мб"
            this.$store.commit("snackbar", "Файл больше 30Мб")
            return
          }
          this.loader.show = true
          const data = new FormData()
          data.append("file", file)
          this.$axios
            .post("/api/common/media/", data, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
            .then(response => {
              document.getElementById("input_file").value = ""
              console.log('response.data.data', response.data)
              if (response.data.error) {
                this.$store.commit("snackbar", "Ошибка при сохранении данных")
                // this.error.file = "Не удалось загрузить media файл"
              } else {
                this.form.file = response.data.data[0]
                console.log('this.form.file', this.form.file)
                this.$emit('input', this.form.file)
              }
              this.loader.show = false
            })
            .catch(error => {
              document.getElementById("input_file").value = ""
              this.$store.commit(
                "snackbar",
                error || "Ошибка при сохранении данных"
              )
              this.loader.show = false
              // this.error.files = "Не удалось загрузить media файл"
            })
        } /* else {
          this.error.files = "Не удалось загрузить media файл"
        } */
    }
  }
}
</script>
